

const theme = {
    //background: "#222222",
    axis: {
      // fontSize: "100px",
      // tickColor: "#eee",
      ticks: {
        // line: {
        //   stroke: "#555555"
        // },
        text: {
          fill: "#4d4f52",
          fontSize: "1.1rem"
        }
      },
      legend: {
        text: {
          fill: "#4d4f52",
          fontSize: "1.6rem",
          fontWeight: 550,
          fontFamily: "Helvetica"
        }
      }
    },
    labels: {
      text: {
        fontSize: "1.6rem",
        fontWeight: 550,
        fontFamily: "Helvetica",
        fill: "#4d4f52"
      }
    }
    // Grid Lines
    // grid: {
    //   line: {
    //     stroke: "#555555"
    //   }
    // }
  };
  
  export default theme;